<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" :maxLength="32" :placeholder="$t('请输入')+'用户手机号'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="变动类型" prop="changeType">
                <a-select v-model="queryParam.changeType" :maxLength="32" :placeholder="$t('请选择')+'账单类型'" allow-clear>
                  <a-select-option v-for="item in customDict.AmountChangeTypeEnum" :key="item.type">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="支付类型" prop="payType">
                <a-select v-model="queryParam.payType" :maxLength="32" :placeholder="$t('请选择')+'支付类型'" allow-clear>
                  <a-select-option v-for="item in customDict.OrderPayTypeEnum" :key="item.type">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="来源" prop="source">
                <a-select v-model="queryParam.source" :maxLength="32" :placeholder="$t('请选择')+'余额类型'" allow-clear>
                  <a-select-option v-for="item in customDict.UserBalanceSourceEnum" :key="item.type">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="三方支付单号" prop="transactionId">
                <a-input v-model="queryParam.transactionId" :maxLength="32" :placeholder="$t('请输入')+'三方支付单号 如微信重置后的流水id'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                   :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                   :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:userbalancerecord:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="changeType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.AmountChangeTypeEnum" :color="true" :color-array="['green', 'red']" :value="record.changeType"/>
        </span>
        <span slot="payType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.OrderPayTypeEnum" :color="true" :value="record.payType"/>
        </span>
        <span slot="source" slot-scope="text, record">
          <custom-dict-tag :options="customDict.UserBalanceSourceEnum" :color="true"  :value="record.source"/>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUserBalanceRecord,listUserBalanceRecord } from '@/api/user/userBalanceRecord'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserBalanceRecord',
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: undefined,
        beforeBalance: undefined,
        balance: undefined,
        afterBalance: undefined,
        source: undefined,
        changeType: undefined,
        payType: undefined,
        transactionId: undefined,
        fromUserId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作前余额',
          dataIndex: 'beforeBalance',
          align: 'center'
        },
        {
          title: '变动余额',
          dataIndex: 'balance',
          align: 'center'
        },
        {
          title: '操作后余额',
          dataIndex: 'afterBalance',
          align: 'center'
        },
        {
          title: '来源',
          dataIndex: 'source',
          scopedSlots: { customRender: 'source' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '方向',
          dataIndex: 'changeType',
          scopedSlots: { customRender: 'changeType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '支付方式',
          dataIndex: 'payType',
          scopedSlots: { customRender: 'payType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '三方支付单号',
          dataIndex: 'transactionId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询用户余额充值记录列表 */
    getList () {
      this.loading = true
     pageUserBalanceRecord(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        mobile: undefined,
        beforeBalance: undefined,
        balance: undefined,
        afterBalance: undefined,
        source: undefined,
        changeType: undefined,
        payType: undefined,
        transactionId: undefined,
        fromUserId: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUserBalanceRecord(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/user/user/balance/record/export',
            that.queryParam
          , `用户余额充值记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
